import { Grid, Paper, Typography } from '@mui/material';

import { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Logo from 'assets/thro-logo.svg';
import { translations } from 'locales/i18n';
import theme from 'styles/theme/theme';
import { useLayout } from 'utils/hooks/useLayout';

import Confirm from './Confirm';
import Forgot from './Forgot';
import { LoginSelection } from './LoginSelection';
import ProcessLogin from './ProcessLogin';

interface Props {
  variant: 'login' | 'forgot' | 'confirm';
  query?: any;
}

export function LoginLayout({ variant, query }: Props) {
  const { t } = useTranslation();
  const location = useLocation();

  const layout = useLayout();
  useLayoutEffect(() => layout.setWithoutLayout(true), [layout]);

  if (location.pathname.includes('/success')) {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const refreshToken = params.get('refreshToken');
    if (token && refreshToken) {
      localStorage.setItem('jwt-token', token);
      localStorage.setItem('refresh-token', refreshToken);
      return <ProcessLogin query={query} />;
    }
  }

  const renderForm = () => {
    switch (variant) {
      case 'login':
        return <LoginSelection />;
      case 'confirm':
        return (
          <Grid
            container
            component={Paper}
            elevation={3}
            style={{
              width: '70%',
              marginLeft: '8em',
              marginTop: '4em',
              marginRight: '12em',
              paddingTop: '2em',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: '85%'
            }}
          >
            <Confirm />
          </Grid>
        );
      case 'forgot':
        return (
          <Grid
            container
            component={Paper}
            elevation={3}
            style={{
              width: '70%',
              marginLeft: '8em',
              marginTop: '4em',
              marginRight: '12em',
              paddingTop: '2em',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: '85%'
            }}
          >
            <Forgot />
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <Grid container style={{ backgroundColor: theme('de').palette.primary.light, height: '100%' }}>
      <Helmet>
        <title>{t(translations.pages.login.title())}</title>
      </Helmet>
      <Grid
        item
        xs={8}
        sm={4}
        md={5}
        component={Paper}
        elevation={6}
        style={{
          borderTopRightRadius: '550px',
          borderBottomRightRadius: '550px',
          boxShadow: `0px 3px 5px -1px ${theme('de').palette.primary.main}dd, 0px 6px 10px 0px ${
            theme('de').palette.primary.main
          }aa, 0px 1px 18px 0px ${theme('de').palette.primary.main}80`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        <Grid container sx={{ maxWidth: { xs: '200px', md: '400px' } }}>
          <img src={Logo} alt="logo" />
        </Grid>
        <Typography
          fontSize={{ xs: '20pt', lg: '50pt' }}
          color={`${theme('de').palette.secondary.main}80`}
        >
          Intern
        </Typography>
      </Grid>
      <Grid item md={1} />
      <Grid item xs={12} sm={8} md={6}>
        {renderForm()}
      </Grid>
    </Grid>
  );
}
